import moment from 'moment';

const convertTimestamp = (timestamp: string) => {
  const regex = /(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}).\d+ (\+\d{4})/;
  const match = regex.exec(timestamp);

  if (match) {
    const timezone = match[2].replace(/(\+\d{2})(\d{2})/, '$1:$2');

    return match[1] + timezone;
  }

  return timestamp;
};

const isDateInPastTenMinutes = (inputDate: string) => {
  if (!inputDate) return false;

  const date = moment(convertTimestamp(inputDate));

  if (!date.isValid()) {
    return false;
  }

  const now = moment();

  const minutesPassed = now.diff(date, 'minutes');

  return Math.abs(minutesPassed) >= 10; // Check within the past ten minutes
};

export { isDateInPastTenMinutes };
